angular.module('app')
  .directive('spinner', function ($http) {
    return {
      restrict: 'C',
      link: (scope, element) => {
        scope.isLoading = () => $http.pendingRequests.length > 0;

        scope.$watch(scope.isLoading, (newValue) => {
          if (newValue) {
            element.removeClass('ng-hide');
          } else {
            element.addClass('ng-hide');
          }
        });
      },
    };
  });
